<ul class="nav nav-pills" id="myTab" role="tablist">
  <li class="nav-item" role="presentation">
    <a class="nav-link active" id="devices-tab" data-bs-toggle="tab" href="#devices" role="tab" aria-controls="devices"
      aria-selected="true">List of Devices</a>
  </li>
  <li class="nav-pills" role="presentation">
    <a class="nav-link" id="consumption-tab" data-bs-toggle="tab" href="#consumption" role="tab"
      aria-controls="consumption" aria-selected="false">Usage MB</a>
  </li>
</ul>

<div class="tab-content" id="myTabContent">
  <div class="tab-pane fade show active" id="devices" role="tabpanel" aria-labelledby="devices-tab">
    <div>
      <div class="row row-device">
        <div class="col-4">
          <div class="mb-3 d-flex justify-content-between">
            <h2 class="title-list">List of Devices</h2>
          </div>
        </div>
        <div class="col-8">
          <div class="d-flex justify-content-end gap-2">
            <div class="me-3">

              <div class="mb-3 float-end">
                <input [(ngModel)]="viewArchivedDevices" type="checkbox" class="btn-check" name="options-outlined"
                  id="viewArchivedDevices" autocomplete="off" (change)="onCheckboxChange($event)">
                <label class="btn btn-outline-success" for="viewArchivedDevices"
                  [appTooltip]="'View archived Devices'"><i class="bi bi-archive"></i></label>
              </div>
            </div>

            <!-- Botón desplegable con dos opciones -->
            <div class="dropdown">
              <button class="btn btn-secondary dropdown-toggle custom-hover custom-active" type="button"
                id="dropdownReportButton" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-file-earmark-excel"></i> Export Data
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownReportButton">
                <li>
                  <a class="dropdown-item custom-hover" (click)="exportToExcelListPlanDevicesConsolidated()">
                    <i class="bi bi-file-earmark-text"></i> Consolidated
                  </a>
                </li>
                <li>
                  <a class="dropdown-item custom-hover" (click)="exportToExcelListPlanDevices()">
                    <i class="bi bi-file-earmark-text"></i> Detailed
                  </a>
                </li>
                <li>
                  <a class="dropdown-item custom-hover" (click)="openConfirmationData()">
                    <i class="bi bi-file-earmark-text"></i> Detailed Annual
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>


      <div class="row">




        <app-table-control [data]="devicesPlan" [columns]="columns" [pageSize]="5" (actionClick)="onAction($event)"
          [pageSize]="5" [actionButtons]="actionButtons" [showActions]="showActions" [showCheckboxes]="false"
          (filteredItemsChange)="onFilteredItemsChange($event)"
          [sheetName]="' List of Devices'">
        </app-table-control>


      </div>

    </div>



    <div class="modal fade" id="modalArchive" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
              Device Archive
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
              (click)="updatePlanDeviceStatus(false)"></button>
          </div>
          <div class="modal-body">
            Are you sure you want to Archive this device?
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
              (click)="updatePlanDeviceStatus(false)">
              Close
            </button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
              (click)="updatePlanDeviceStatus(true)">
              Yes, Archive
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="tab-pane fade" id="consumption" role="tabpanel" aria-labelledby="consumption-tab">
    <app-consumption-view [data]="usageData" [useMobileLayout]="true"  ></app-consumption-view>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalUpdatePlan" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
          Update device
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="updateDevice(false)"></button>
      </div>
      <div class="modal-body">
        <div class="fw-bold bg-white p-3 rounded-5 mb-5">
          <!-- Primera fila -->
          <div class="row mt-3">
            <div class="col">
              <label for="iccid">ICCID<span class="required">*</span></label>
              <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="iccid" />
            </div>
            <div class="col">
              <label for="mtn">MDN</label>
              <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="mtn" />
            </div>
            <div class="col">
              <label for="imei" class="">IMEI</label>
              <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="imei" />
            </div>
          </div>

          <!-- Segunda fila -->
          <div class="row mt-3">
            <div class="col">
              <label for="modemType">Modem Type</label>
              <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="modemType" />
            </div>
            <div class="col">
              <label for="serialNumber" class="">Serial Number</label>
              <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="serialNumber" />
            </div>
            <div class="col-4">
              <label for="ip" class="">IP</label>
              <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="ip" />
            </div>
          </div>

          <!-- Tercera fila -->
          <div class="row mt-3">
            <div class="col">
              <label for="deviceName">Username</label>
              <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="deviceName" />
            </div>
            <div class="col-4">
              <label for="deviceName2" class="">Username 2</label>
              <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="deviceName2" />
            </div>
            <div class="col-4">
              <label for="custom1" class="">Custom Field 1</label>
              <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="custom1" />
            </div>
          </div>

          <!-- Cuarta fila -->
          <div class="row mt-3">
            <div class="col-4">
              <label for="custom2" class="">Custom Field 2</label>
              <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="custom2" />
            </div>
            <div class="col">
              <label for="activationDate">Activation Date</label>
              <input type="date" class="form-control input-label" (input)="checkFields()" [(ngModel)]="activationDate"
                id="activationDate" name="activationDate" />
            </div>
            <div class="col">
              <label for="activationDate">Originated From</label>
              <input type="text" class="form-control input-label" (input)="checkFields()"
                [(ngModel)]="originatedFrom" />
            </div>

          </div>
          <div class="row mt-3">



            <div class="col-4 d-flex align-items-center">
              <div class="form-check form-check-edit">
                <input class="checkbox me-2" style="margin-left: -1.5rem" type="checkbox" id="flexCheckDefault"
                  [(ngModel)]="isPrimaryDevice" />
                <label class="form-check-label" for="flexCheckDefault">
                  Primary Device
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateDevice(false)">
          Close
        </button>
        <button type="button" class="btn btn-primary" [disabled]="!fieldsCompleted"
          (click)="openConfirmationModalUpdate()">
          Yes, Update
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Confirmation Update -->
<div class="modal fade" id="confirmationUpdate" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
          Update device
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="updateDevice(false)"></button>
      </div>
      <div class="modal-body">Are you sure you want to update this device?</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateDevice(false)">
          Close
        </button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updateDevice(true)">
          Yes, Update
        </button>
      </div>
    </div>
  </div>
</div>



<!-- Modal Confirmation Data-->
<div class="modal fade" id="confirmationData" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
          Report Filters
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="exportToExcelListPlanDevicesAnnual(false)"></button>
      </div>
      <div class="modal-body">
        <div class="fw-bold bg-white p-3 rounded-5 mb-5">
          <!-- Primera fila -->
          <div class="row mt-3">
            <div class="col">
              <label for="information">{{
                informationFilters
                }}</label>
            </div>
          </div>

          <!-- Segunda fila -->
          <div class="row mt-3">
            <div class="col">
              <label for="fromDate">From Date</label>
              <input type="date" class="form-control input-label" (input)="checkFieldsFilter()" [(ngModel)]="fromDate"
                id="fromDate" name="fromDate" />
            </div>

            <div class="col">
              <label for="toDate">To Date</label>
              <input type="date" class="form-control input-label" (input)="checkFieldsFilter()" [(ngModel)]="toDate"
                [min]="minDate()" id="toDate" name="toDate" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
          (click)="exportToExcelListPlanDevicesAnnual(false)">
          Close
        </button>
        <button type="button" class="btn btn-primary" (click)="exportToExcelListPlanDevicesAnnual(true)"
          [disabled]="!fieldsCompletedFilter">
          Generate Report
        </button>
      </div>
    </div>
  </div>
</div>
